<template>
<div class="chapter">
<div class="inner_page">
<p class="blackquote"><a id="file_010"></a><a id="page_6"><em>Most of the projects in this book require simple materials. A felting needle, wool, and a foam pad are needed for all projects. Resources for where to find these items are listed on </em></a><em><span class="nounder" href="#/xhtml/file_516#file_516" title="Link target outside of Sample">page 128</span>.</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// file_010.vue?6a6ed86f